import React, { useEffect, useState } from "react";

const PolicyDetailsModal = ({ open, onClose, policiesDetails = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const highlightMatch = (text) => {
    if (!searchTerm || typeof text !== "string") return text;

    const lowerText = text.toLowerCase();
    const lowerSearch = searchTerm.toLowerCase();

    if (!lowerText.includes(lowerSearch)) return text;

    const regex = new RegExp(`(${searchTerm})`, "gi");

    return text.split(regex).map((part, i) =>
      part.toLowerCase() === lowerSearch ? (
        <mark key={i} className="font-semibold bg-yellow-300">
          {part}
        </mark>
      ) : (
        <span key={i}>{part}</span>
      ),
    );
  };

  const matchesSearch = (value) =>
    !searchTerm ||
    JSON.stringify(value).toLowerCase().includes(searchTerm.toLowerCase());

  useEffect(() => {
    setSearchTerm("");
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white w-full max-w-6xl max-h-[80vh] rounded-lg shadow-lg relative flex flex-col">
        <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 bg-white border-b">
          <h2 className="text-2xl font-bold">Policy Details</h2>
          <button
            onClick={onClose}
            className="text-2xl font-bold text-gray-500 hover:text-gray-800"
          >
            &times;
          </button>
        </div>

        <div className="sticky top-[4.5rem] z-10 px-6 py-2 bg-white border-b">
          <div className="flex justify-end">
            <input
              type="text"
              placeholder="Search policy content..."
              className="w-full max-w-sm px-4 py-2 text-lg border border-gray-300 rounded-md"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="px-6 py-4 overflow-y-auto grow">
          <div className="space-y-6 text-lg">
            {policiesDetails
              .filter((policy) => matchesSearch(policy))
              .map((policy, index) => (
                <div
                  key={index}
                  className="p-4 border border-gray-300 rounded-md shadow-sm"
                >
                  <h3 className="mb-2 text-xl font-bold">
                    {highlightMatch(policy.policyName)}
                  </h3>
                  <p className="mb-4 text-base text-gray-700">
                    Policy ID: {highlightMatch(policy.policyId)}
                  </p>

                  {policy.policyDocument && (
                    <>
                      <p className="mb-2 font-semibold">
                        Version:{" "}
                        <span className="font-normal">
                          {highlightMatch(policy.policyDocument.Version)}
                        </span>
                      </p>

                      {policy.policyDocument.Statement.map((statement, idx) => (
                        <div
                          key={idx}
                          className="pt-4 mt-4 border-t border-gray-200"
                        >
                          <p className="text-lg font-semibold">
                            Statement {idx + 1}
                          </p>
                          {statement.Sid && (
                            <p>
                              <strong>Sid:</strong>{" "}
                              {highlightMatch(statement.Sid)}
                            </p>
                          )}
                          <p>
                            <strong>Effect:</strong>{" "}
                            {highlightMatch(statement.Effect)}
                          </p>

                          <div className="mt-2">
                            <strong>Actions:</strong>
                            <ul className="mt-1 ml-6 list-disc">
                              {Array.isArray(statement.Action) ? (
                                statement.Action.map((action, aidx) => (
                                  <li key={aidx}>{highlightMatch(action)}</li>
                                ))
                              ) : (
                                <li>{highlightMatch(statement.Action)}</li>
                              )}
                            </ul>
                          </div>

                          <div className="mt-2">
                            <strong>Resources:</strong>
                            <ul className="mt-1 ml-6 list-disc">
                              {Array.isArray(statement.Resource) ? (
                                statement.Resource.map((res, ridx) => (
                                  <li key={ridx}>{highlightMatch(res)}</li>
                                ))
                              ) : (
                                <li>{highlightMatch(statement.Resource)}</li>
                              )}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              ))}
          </div>
        </div>

        <div className="sticky bottom-0 z-10 flex justify-end px-6 py-4 bg-white border-t">
          <button
            onClick={onClose}
            className="px-6 py-2 text-lg text-white bg-blue-600 rounded hover:bg-blue-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PolicyDetailsModal;
